module.exports = __webpack_public_path__ + "static/img/9.a58e4d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/9.png
// module id = ZGji
// module chunks = 0